import React, { FC, useCallback, useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ThunkGetPortalConfig } from 'store/config/thunks';

import AppProviders from 'components/AppProviders';
import Loader from 'components/Loader';

import useStyles from './styles';
import { ThemeModeSelector } from './store/themeMode';
import { languages } from './services/config/types';
import i18n from '@i18n/i18n';

const App: FC = () => {
  const themeMode = useAppSelector(ThemeModeSelector);

  const [loading, setLoading] = useState<boolean>(true);

  const dispatch = useAppDispatch();
  const classes = useStyles({ themeMode });

  const onMount = useCallback(() => {
    setLoading(true);
    dispatch(ThunkGetPortalConfig())
      .unwrap()
      .then(({ language }) => {
        i18n.changeLanguage(languages[language]);
      }).catch(err => { console.error(err); })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  if (loading) return <Loader />;
  return (
    <div className={classes.app}>
      <AppProviders>
        <></>
      </AppProviders>
    </div>
  );
};

export default App;
